import type { SeatingChart as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util/takePayload';

export type SeatingChart = {
  id: number;
  key: string;
  name: string;
  status?: string;
  hasDraft?: boolean;
  deletable: boolean;
  usable: boolean;
  draftThumbnailUrl?: string;
  publishedThumbnailUrl?: string;
  parentId?: number;
};

export const fromGql = (item: GQLItem): SeatingChart => ({
  ...take<SeatingChart>(item, 'id', 'key', 'name', 'deletable', 'usable'),
  status: item.status ?? undefined,
  hasDraft: item.hasDraft ?? undefined,
  draftThumbnailUrl: item.draftThumbnailUrl ?? undefined,
  publishedThumbnailUrl: item.publishedThumbnailUrl ?? undefined,
  parentId: item.parentId ?? undefined,
});
